import "regenerator-runtime/runtime";
import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import App from "App";
import theme from "assets/theme";
import themeDark from "assets/theme-dark";
import { MaterialUIControllerProvider, useMaterialUIController } from "context";

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root element #root not found");
}

const root = createRoot(container);

function ThemeProviderWrapper({ children }: { children: React.ReactNode }) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller as { darkMode: boolean };

  return (
    <ThemeProvider theme={darkMode ? themeDark : theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}

root.render(
  <BrowserRouter>
    <MaterialUIControllerProvider>
      <ThemeProviderWrapper>
        <App />
      </ThemeProviderWrapper>
    </MaterialUIControllerProvider>
  </BrowserRouter>
);
